export enum GenderTypes {
  Masculine = "masculino",
  Feminine = "femenino",
  Neutral = "prefiero no decirlo",
}
